module.exports = __webpack_public_path__ + "img/note.b6ce11f6.png";